import { render, staticRenderFns } from "./ClaioSchemaThumbnail.vue?vue&type=template&id=15a9dae9&scoped=true&"
import script from "./ClaioSchemaThumbnail.vue?vue&type=script&lang=ts&"
export * from "./ClaioSchemaThumbnail.vue?vue&type=script&lang=ts&"
import style0 from "./ClaioSchemaThumbnail.vue?vue&type=style&index=0&id=15a9dae9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a9dae9",
  null
  
)

export default component.exports